import { Card } from "primereact/card";
import { useState } from "react";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import { Tooltip } from "primereact/tooltip";

import { SaveAnswer } from "interfaces";
import { labelFonti, labelNoSource, labelSavedFor } from "_constants";
import { ModalDetailResponse } from "./ModalDetailResponse";
import { useAppDispatch, useAppSelector } from "store/store";
import {
  setCurrentAnswer,
  setToggleCheckId,
} from "store/slicer/GestioneSaveAnswerSlice";
import { getDetailPinnedAnswer } from "services";
import { ReactMarkdownAI } from "components/shared";

export const SaveResponseCard = ({
  answer,
  projectId,
}: {
  answer: SaveAnswer;
  projectId: string;
}) => {
  const dispatch = useAppDispatch();
  const selectButton = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.select
  );
  const checkIds = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.checkIds
  );
  const [openModalDetailResponse, setOpenModalDetailResponse] =
    useState<any>(false);

  const setCheckSlice = (e: CheckboxChangeEvent) => {
    dispatch(setToggleCheckId(answer.id));
  };

  const openModal = () => {
    getDetailPinnedAnswer(answer.id)
      .then((response) => {
        dispatch(setCurrentAnswer(response.data as any));
        setOpenModalDetailResponse(true);
      })
      .catch((error: any) => {
        console.error(error.message);
      });
  };

  const header = (
    <div className="padd-18 padd-bottom-0">
      <div className="flex-container width-100 justify-between">
        <Tooltip
          target={`.tooltip-title`}
          position="bottom"
          mouseTrack
          mouseTrackLeft={10}
        />
        <h5
          className=" max-width-80 font-weight-700 text-title tooltip-title  ellipsis-text"
          data-pr-tooltip={answer.title}
        >
          {answer.title}
        </h5>
        {selectButton && (
          <Checkbox
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              setCheckSlice(e);
            }}
            checked={checkIds.some((selectId: any) => selectId === answer.id)}
          />
        )}
      </div>
      <div className="flex-container gap-4 margin-top-4">
        <span className="text-base-regular">{labelSavedFor}</span>
        <span className="text-base-regular-semibold max-width-70 ellipsis-text capitalize ">
          {answer.savedBy}
        </span>
      </div>
    </div>
  );

  const footer = (
    <>
      <Divider />
      <div className="footer-card">
        <div className="container-chip">
          {answer.codeSourceTotal > 0 && (
            <div className="chip chip-codici"></div>
          )}
          {answer.archiveSourceTotal > 0 && (
            <div className="chip chip-archivio"></div>
          )}
          {answer.privateSourceTotal > 0 && (
            <div className="chip chip-privato"></div>
          )}
        </div>
        <span
          className={`${
            answer.archiveSourceTotal +
              answer.codeSourceTotal +
              answer.privateSourceTotal >
            0
              ? "margin-left-4 bold "
              : "italic"
          }`}
        >
          {answer.archiveSourceTotal +
            answer.codeSourceTotal +
            answer.privateSourceTotal ===
          0
            ? labelNoSource
            : answer.archiveSourceTotal +
              answer.codeSourceTotal +
              answer.privateSourceTotal +
              " " +
              labelFonti}
        </span>
      </div>
    </>
  );

  return (
    <>
      <Card
        header={header}
        className="custom-card-response cta"
        footer={footer}
        onClick={() => openModal()}
      >
        <ReactMarkdownAI message={answer.message?.replace(/\n/g, "  \n  ")} />
      </Card>
      {openModalDetailResponse && (
        <ModalDetailResponse
          projectId={projectId}
          answerId={answer.id}
          modalVisibile={openModalDetailResponse}
          onClose={() => setOpenModalDetailResponse(false)}
        />
      )}
    </>
  );
};
